import { DefectTypes } from "../../classes/Api/Inspection";
const dentablePanels = [
    'Rear Door',
    'Front Door',
    'Rear Quarter',
    'Rear Arch',
    'Front Arch',
    'Wing',
    'Front Pillar',
    'Rear Bumper',
    'Tailgate',
    'Front Bumper',
    'Bonnet',
    'Roof',
];
const glassPanels = [
    'Rear Glass',
    'Windscreen'
];
const wheels = [
    'Front Wheel',
    'Rear Wheel',
];
const tyres = [
    'Front Tyre',
    'Rear Tyre',
];
const interior = [
    'Drivers Seat',
    'Passenger Seat',
    'Drivers-side Rear Seat',
    'Middle - Rear Seat',
    'Passenger-side Rear Seat',
    'Drivers-side Boot Seat',
    'Passenger-side Boot Seat',
    'Centre Console',
    'Dash',
    'Steering Wheel',
    'Front Carpet',
    'Rear Carpet',
    'Drivers Door Card',
    'Passenger Door Card',
];
const guessTemplateTypeByName = (templates, defect, name) => {
    let names = name;
    if (typeof name !== 'object') {
        names = [name];
    }
    for (const name of names) {
        // Try finding a template.
        const template = templates.find(i => i.title.toLowerCase().indexOf(name) > -1);
        if (template) {
            let option = guessTemplateOption(template, defect);
            if (option) {
                return option;
            }
            // If not found return the template.
            return {
                template,
                option: { id: template.id, type: 'task.template' },
            };
        }
    }
    return null;
};
const guessTemplateOption = (template, defect) => {
    // Nearside - Front Door ---> ['nearside','front door']
    // Tailgate ---> ['tailgate']
    const panelParts = defect?.panel?.toLowerCase().split(' - ');
    let sideAbbr = '';
    let panel = panelParts ? panelParts[0] : undefined;
    // Task templates use an abbreviation of (O/S) or (N/S) within thier titles.
    if (panelParts?.length === 2) {
        if (panelParts[0] === 'nearside') {
            sideAbbr = 'n/s';
        }
        else if (panelParts[0] === 'offside') {
            sideAbbr = 'o/s';
        }
        panel = panelParts[1];
    }
    // Try finding the first form of template option e.g. Wing (O/S), Front Door (O/S), etc
    let option = template.options.find(i => {
        const isCorrectSide = i.title.toLowerCase().indexOf(sideAbbr) > -1;
        const isCorrectPanel = i.title.toLowerCase().indexOf(panel ?? '') > -1;
        return isCorrectPanel && isCorrectSide;
    });
    if (option) {
        return {
            template: option,
            option: { id: option.id, type: 'task.template.option' }
        };
    }
    // Try finding the second form of the template option e.g. O/S/F, N/S/R, etc
    if (defect.panel && defect.panel.toLowerCase().indexOf('front') > -1) {
        sideAbbr += '/f';
    }
    else if (defect.panel && defect.panel.toLowerCase().indexOf('rear') > -1) {
        sideAbbr += '/r';
    }
    option = template.options.find(i => {
        return i.title.toLowerCase().indexOf(sideAbbr) > -1;
    });
    if (option) {
        return {
            template: option,
            option: { id: option.id, type: 'task.template.option' }
        };
    }
    // Try finding the third form of template option e.g. Offside - Front Bumper => Front Bumper
    option = template.options.find(i => {
        return i.title.toLowerCase().indexOf(panel ?? '') > -1;
    });
    if (option) {
        return {
            template: option,
            option: { id: option.id, type: 'task.template.option' }
        };
    }
    return;
};
const contains = (needle, haystack) => {
    return haystack.indexOf(needle) > -1;
};
const getMappings = (type) => {
    // @ts-ignore
    return window.marque.ui.inspectionMappings.bodywork.guess_mappings[type];
};
const guessTemplate = (templates, defect) => {
    // --- Dentable Panels ---
    if (dentablePanels.find(i => contains(i, defect.panel ?? ''))) {
        // Chip/Scratch/Scuff/Crack - SMART Repair
        const smartTypes = [
            DefectTypes.CHIP,
            DefectTypes.SCRATCH,
            DefectTypes.SCUFF,
            DefectTypes.CRACK
        ];
        if (smartTypes.includes(defect.type ?? '')) {
            return guessTemplateTypeByName(templates, defect, getMappings('smart'));
        }
        // Dent - Dent Removal
        if (defect.type === DefectTypes.DENT) {
            return guessTemplateTypeByName(templates, defect, getMappings('dent'));
        }
        // Panel
        if (defect.type === DefectTypes.PANEL) {
            return guessTemplateTypeByName(templates, defect, getMappings('panel'));
        }
    }
    // --- Glass Panels ---
    if (glassPanels.find(i => contains(i, defect.panel ?? ''))) {
        // Chip - Windscreen Repair
        if ([DefectTypes.CHIP, DefectTypes.SCRATCH].includes(defect.type ?? '')) {
            return guessTemplateTypeByName(templates, defect, getMappings('windscreen_repair'));
        }
        // Crack - Windscreen Replacement
        if ([DefectTypes.CRACK, DefectTypes.PART_REPLACEMENT].includes(defect.type ?? '')) {
            return guessTemplateTypeByName(templates, defect, getMappings('windscreen_replacement'));
        }
    }
    // --- Wheels ---
    if (wheels.find(i => contains(i, defect.panel ?? ''))) {
        // Chip/Scratch/Scuff/Crack - Wheel Refurb
        const refurbTypes = [
            DefectTypes.CHIP,
            DefectTypes.SCRATCH,
            DefectTypes.SCUFF,
            DefectTypes.CRACK,
        ];
        if (refurbTypes.includes(defect.type ?? '')) {
            return guessTemplateTypeByName(templates, defect, getMappings('wheel_refurbishment'));
        }
    }
    // --- Tyres ----
    if (tyres.find(i => contains(i, defect.panel ?? ''))) {
        // Worn - Tyre replacement
        if (defect.type === DefectTypes.WORN) {
            return guessTemplateTypeByName(templates, defect, getMappings('tyre_replacement'));
        }
    }
    // --- Interior ----
    if (interior.find(i => contains(i, defect.panel ?? ''))) {
        const refurbTypes = [
            DefectTypes.CHIP,
            DefectTypes.SCRATCH,
            DefectTypes.SCUFF,
            DefectTypes.CRACK,
            DefectTypes.WORN,
            DefectTypes.DENT,
            DefectTypes.OTHER,
        ];
        if (refurbTypes.includes(defect.type)) {
            return guessTemplateTypeByName(templates, defect, getMappings('interior'));
        }
    }
    // Part Replacement
    if (defect.type === DefectTypes.PART_REPLACEMENT) {
        return guessTemplateTypeByName(templates, defect, getMappings('parts'));
    }
    return null;
};
export { guessTemplate, dentablePanels, glassPanels, wheels, tyres, interior, contains, };
